import React from 'react'

const Input = ({
  label,
  placeholder,
  value,
  defaultValue,
  type,
  textArea,
  errorMessage,
  icon,
  onChange = () => {},
  classNames = '',
  inputClassNames = '',
}) => {
  return (
    <div className={classNames}>
      {label && <div className="capitalize text-lg font-medium">{label}</div>}
      <form className={`flex items-center px-4 min-h-[40px] w-full ${inputClassNames}`}>
        {icon && icon}
        {textArea ? (
          <textarea
            value={value}
            className="bg-transparent border-0 text-black w-full text-[14.4px] resize-none"
            onChange={onChange}
            placeholder={placeholder}
            type={type || 'text'}
            rows={Math.min(Math.ceil(value?.length / 65), 5) || 1}
          />
        ) : (
          <input
            value={value}
            className="bg-transparent border-0 text-black w-full text-[14.4px]"
            onChange={onChange}
            placeholder={placeholder}
            type={type || 'text'}
            defaultValue={defaultValue}
          />
        )}
      </form>
      {errorMessage && <span className="text-red-400 text-xs font-semibold absolute mt-0.5">{errorMessage}</span>}
    </div>
  )
}

export default Input
